import { createFileRoute } from '@tanstack/react-router';
import { Mail, MapPin } from 'lucide-react';
import { LegalPage } from '../components/legal-page';
import { useDemoModal } from '../components/demo-modal-context';

export const Route = createFileRoute('/contact')({
  component: ContactPage,
});

function ContactPage() {
  const { open } = useDemoModal();
  return (
    <LegalPage title="Contact" lead="The fastest way to reach us is the demo request form.">
      <div className="not-prose grid gap-4 md:grid-cols-2">
        <div className="rounded-2xl border border-border bg-white p-6 shadow-sm">
          <Mail className="h-5 w-5 text-primary" strokeWidth={1.75} />
          <h3 className="mt-4 text-base font-semibold text-ink">Email</h3>
          <p className="mt-1 text-sm text-ink-2">
            <a className="text-primary underline" href="mailto:hello@lynrx.co">
              hello@lynrx.co
            </a>
          </p>
          <p className="mt-2 text-xs text-ink-3">We reply within one business day.</p>
        </div>

        <div className="rounded-2xl border border-border bg-white p-6 shadow-sm">
          <MapPin className="h-5 w-5 text-primary" strokeWidth={1.75} />
          <h3 className="mt-4 text-base font-semibold text-ink">Mailing</h3>
          <p className="mt-1 text-sm text-ink-2">LYN Rx LLC</p>
          <p className="text-sm text-ink-2">Ohio, USA</p>
        </div>
      </div>

      <p>
        For demos, the request form is the fastest path — it goes directly to the founder.
      </p>
      <button
        type="button"
        onClick={open}
        className="not-prose inline-flex items-center justify-center rounded-lg bg-ink px-5 py-3 text-sm font-medium text-white shadow-sm transition-colors hover:bg-ink/90"
      >
        Request a demo
      </button>
    </LegalPage>
  );
}
